import { IssueUpdateService as OvermapIssueUpdateService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueUpdateService extends OvermapIssueUpdateService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
